import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "articles-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = {
  key: 0,
  class: "loading"
}
const _hoisted_4 = {
  key: 1,
  class: "articles-grid"
}

import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import ArticleCard from '@/components/ArticleCard.vue'
import { getArticlesMeta } from '@/utils/articles'
import type { ArticleMeta } from '@/types/articles'


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticlesPage',
  setup(__props) {

const { t, locale } = useI18n()
const articles = ref<ArticleMeta[]>([])
const loading = ref(true)

const loadArticles = async () => {
    try {
        loading.value = true
        articles.value = await getArticlesMeta(locale.value)
    } catch (error) {
        console.error('Error loading articles:', error)
        articles.value = []
    } finally {
        loading.value = false
    }
}

watch(locale, loadArticles, { immediate: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(t)('articles.title')), 1),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articles.value, (article) => {
            return (_openBlock(), _createBlock(ArticleCard, {
              class: "card",
              key: article.slug,
              article: article
            }, null, 8, ["article"]))
          }), 128))
        ]))
  ]))
}
}

})